import React, { useMemo } from "react";
import BaseDataTable from "./BaseDataTable";
import { buildRegistryColumns } from "../config/maintenanceRegistryConfig";

export default function MaintenanceRegistryTable({ rows = [], assetType }) {
  const columns = useMemo(() => buildRegistryColumns(assetType), [assetType]);

  return (
    <BaseDataTable
      columns={columns}
      data={rows}
      mrtProps={{
        enableTopToolbar: false,
        enableBottomToolbar: true,
        initialState: {
          pagination: { pageIndex: 0, pageSize: 10 },
        },
        muiTablePaperProps: {
          elevation: 0,
          sx: {
            borderRadius: 2,
          },
        },
      }}
    />
  );
}
